const NoVariables = () => {
  return (
    <div>
      There's no variables yet, please add variables by clicking the "Add" button at the top.
    </div>
  )
}

export default NoVariables